import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { baseUrlApi } from '../../utils/url';
import { RootState } from './store';

export interface EdlPicture {
  id: number;
  url: string;
  EdlElementId: number;
  LocalId: number;
}

interface EdlPictureState {
  picturesByLocal: EdlPicture[];   // toutes les photos du local courant
  loading: boolean;
  error: string | null;
}

const initialState: EdlPictureState = {
  picturesByLocal: [],
  loading: false,
  error: null,
};

const getToken = (state: RootState) => (state as any).authentification?.user?.token;

export const fetchEdlPicturesByLocal = createAsyncThunk<EdlPicture[], number, { state: RootState }>(
  'edlPicture/fetchByLocal',
  async (localId, { getState, rejectWithValue }) => {
    try {
      const res = await axios.get(`${baseUrlApi}/edlelements/local/${localId}/pictures`, {
        headers: { Authorization: `bearer ${getToken(getState())}` },
      });
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || 'Failed');
    }
  }
);

export const uploadEdlPicture = createAsyncThunk<
  EdlPicture,
  { elementId: number; file: File; localId: number },
  { state: RootState }
>(
  'edlPicture/upload',
  async ({ elementId, file, localId }, { getState, dispatch, rejectWithValue }) => {
    try {
      const fd = new FormData();
      fd.append('photo', file);
      const res = await axios.post(`${baseUrlApi}/edlelements/${elementId}/pictures`, fd, {
        headers: { Authorization: `bearer ${getToken(getState())}` },
      });
      dispatch(fetchEdlPicturesByLocal(localId));
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || 'Upload failed');
    }
  }
);

export const deleteEdlPicture = createAsyncThunk<
  void,
  { picId: number; localId: number },
  { state: RootState }
>(
  'edlPicture/delete',
  async ({ picId, localId }, { getState, dispatch, rejectWithValue }) => {
    try {
      await axios.delete(`${baseUrlApi}/edlelements/pictures/${picId}`, {
        headers: { Authorization: `bearer ${getToken(getState())}` },
      });
      dispatch(fetchEdlPicturesByLocal(localId));
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || 'Delete failed');
    }
  }
);

const edlPictureSlice = createSlice({
  name: 'edlPicture',
  initialState,
  reducers: {
    clearEdlPictures: (state) => { state.picturesByLocal = []; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEdlPicturesByLocal.pending,  (state) => { state.loading = true; state.error = null; })
      .addCase(fetchEdlPicturesByLocal.rejected, (state, action: any) => { state.loading = false; state.error = action.payload; })
      .addCase(fetchEdlPicturesByLocal.fulfilled, (state, action) => {
        state.loading         = false;
        state.picturesByLocal = action.payload;
      });
  },
});

export const { clearEdlPictures } = edlPictureSlice.actions;
export default edlPictureSlice.reducer;
